import React, { useEffect, useState } from "react";
import StandAloneInput from "../../../../../../components/stand-alone-input";
import { tradeClassSources } from "../../../../../../utils/constants";
import Select from "react-select";
const Employee = props => {
    const [editJourDefault, setEditJourDef] = useState(true);
    const [editTradeClassDef, setEditTradeClassDef] = useState(true);
    const [editJourField, setEditJourField] = useState(true);
    const [editTradeClassField, setEditTradeClassField] = useState(true);
    const [tcSourceOptions, setTCSourceOptions] = useState([]);
    const [selectedSource, setSelectedSource] = useState({});

    useEffect(() => {
        setTCSourceOptions(tradeClassSources);
        let savedSource = props.tradeClassSource;
        let selected = tcSourceOptions.find(src => src.value === savedSource);
        setSelectedSource(selected);
    }, [props.tradeClassSource]);

    function onValueChange(e, fieldName) {

        return props.onChange(e, fieldName);
    };


    function handleChange(e) {
        setSelectedSource(e);
        return props.onChange(e, "tradeClassSource");
    };

    function setEditField(field) {
        switch (field) {
            case "jourField": {
                setEditJourField(!editJourField);
                break;
            };
            case "tradeClassField": {
                setEditTradeClassField(!editTradeClassField);
                break;
            };
            case "jourDefault": {
                setEditJourDef(!editJourDefault);
                break;
            };
            case "tradeClassDef": {
                setEditTradeClassDef(!editTradeClassDef);
                break;
            };
        };
    };

    return (
        <div className="ec_setup_contact reg ">

            {editJourField ? (
                <div className="reportId d-flex align-items-center justify-content-between">

                    <div className="reportIdField repordIDCS_wd_100">
                        <label>Journyperson / apprentice custom field num</label>
                        <p className="repordIDCS">
                            {props.jouOrApprenField || "custom field for Journeyperson / apprentice"}
                        </p>
                    </div>

                    <div className="reportIdField">
                        <button className="btn reportBtn"
                            onClick={() => setEditField("jourField")}
                        >
                            Edit
                        </button>
                    </div>
                </div>

            ) : (

                <div className="SavedReports reportId df align-items-center justify-content-between margin-top-10">
                    <div className="input_line ssD_fiels">
                        <label>Journyperson / apprentice custom field num</label>
                        <StandAloneInput
                            value={props.jouOrApprenField}
                            placeholder={"Enter the Custom field for Journeyperson / apprentice settings"}
                            change={e => onValueChange(e, "jourField", true)}
                            id="rprt_inpt"
                        ></StandAloneInput>
                    </div>

                    <button className="btn reportBtn"
                        onClick={() => setEditField("jourField")}
                    >
                        Close
                    </button>
                </div>
            )}
            {editJourDefault ? (
                <div className="reportId d-flex align-items-center justify-content-between">

                    <div className="reportIdField repordIDCS_wd_100">
                        <label>Journyperson / apprentice default value</label>
                        <p className="repordIDCS">
                            {props.jourOrApprenDefVal || "Journeyperson / apprentice default value?"}
                        </p>
                    </div>

                    <div className="reportIdField">
                        <button className="btn reportBtn"
                            onClick={() => setEditField("jourDefault")}
                        >
                            Edit
                        </button>
                    </div>


                </div>

            ) : (
                <div className="SavedReports reportId df align-items-center justify-content-between margin-top-10">
                    <div className="input_line ssD_fiels">
                        <label>Journyperson / apprentice default value</label>
                        <StandAloneInput
                            value={props.jourOrApprenDefVal}
                            change={e => onValueChange(e, "jourDefault")}
                            placeholder="Enter Default Value for Journeyperson / apprentice"
                            id="rprt_inpt"
                        ></StandAloneInput>
                    </div>
                    <button className="btn reportBtn"
                        onClick={() => setEditField("jourDefault")}
                    >
                        Close
                    </button>
                </div>
            )}
            <div className="SavedReports reportId df align-items-center justify-content-between margin-top-10">
                <div className="input_line ssD_fiels">
                    <Select
                        options={tcSourceOptions}
                        onChange={handleChange}
                        value={selectedSource}
                    >
                    </Select>
                </div>
            </div>
            {editTradeClassField ? (
                <div className="reportId d-flex align-items-center justify-content-between">

                    <div className="reportIdField repordIDCS_wd_100">
                        <label>Trade Classification custom field num</label>
                        <p className="repordIDCS">
                            {props.tradeClassField || "Trade Classification custom field"}
                        </p>
                    </div>

                    <div className="reportIdField">
                        <button className="btn reportBtn"
                            onClick={() => setEditField("tradeClassField")}
                        >
                            Edit
                        </button>
                    </div>
                </div>
            ) : (

                <div className="SavedReports reportId df align-items-center justify-content-between margin-top-10">
                    <div className="input_line ssD_fiels">
                        <label>Trade Classification custom field num</label>
                        <StandAloneInput
                            value={props.tradeClassField}
                            placeholder={"Enter the Custom field for Trade Classification"}
                            change={e => onValueChange(e, "tradeClassField", true)}
                            id="rprt_inpt"
                        ></StandAloneInput>
                    </div>

                    <button className="btn reportBtn"
                        onClick={() => setEditField("tradeClassField")}
                    >
                        Close
                    </button>
                </div>
            )}
            {editTradeClassDef ? (
                <div className="reportId d-flex align-items-center justify-content-between">

                    <div className="reportIdField repordIDCS_wd_100">
                        <label>Trade Classification default value</label>
                        <p className="repordIDCS">
                            {props.defTradeClass || "Default Trade Classification"}
                        </p>
                    </div>

                    <div className="reportIdField">
                        <button className="btn reportBtn"
                            onClick={() => setEditField("tradeClassDef")}
                        >
                            Edit
                        </button>
                    </div>


                </div>

            ) : (

                <div className="SavedReports reportId df align-items-center justify-content-between margin-top-10">
                    <div className="input_line ssD_fiels">
                        <label>Trade Classification default value</label>
                        <StandAloneInput
                            value={props.defTradeClass}
                            change={e => onValueChange(e, "tradeClassDef")}
                            placeholder="Enter Default Value for Trade Classification"
                            id="rprt_inpt"
                        ></StandAloneInput>
                    </div>
                    <button className="btn reportBtn"
                        onClick={() => setEditField("tradeClassDef")}
                    >
                        Close
                    </button>
                </div>
            )}
        </div>
    )
}

export default Employee;